import React from 'react';
import Rater from 'react-rater';
import { Form } from '@sharingapples/form';

import { Tooltip } from '../../components';

//TODO: use srcset

export default function Banner({ bannerImages, profileImages }) {
  return (
    <Form>
      <div className="banner-holder">
        <div className="cover-image">
          <img className="banner-img" src="https://s3.amazonaws.com/honeyguide/assets/profile-bg.jpg" alt="banner" />
        </div>
        <div className="info">
          <div className="profile-image" style={{ backgroundImage: "url('https://apiv2.honeyguideapps.com/static/user/a4d6fc0c92b7_cl.jpeg')" }} >
            <img alt="profile" src="https://apiv2.honeyguideapps.com/static/user/a4d6fc0c92b7_cl.jpeg" />
          </div>
            <div className="other-detail">
              <div className="guide-detail">
                <h4>Sadeep Dangol</h4>
                <p>Based In: Kathmandu, Nepal</p>
                <p>Experience: 5 + years</p>
                <Rater total={5} rating={3.5} interactive="false" /> <span>3 reviews</span>
              </div>
              <div className="guide-price">
                <h5>
                  USD N/A
                </h5>
                <Tooltip info="Guide Cost without Guide insurance, lodging and fooding">
                  <div className="breakdown">
                    <span>Includes Guide wage</span>
                    <em>i</em>
                  </div>
                </Tooltip>
            </div>
          </div>
        </div>
      </div>
    </Form>
  );
}
